
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1B2xl", function(module, exports) {

$parcel$export(module.exports, "getRandomUniqueNumbers", () => $ecc34a56e3ca8c79$export$cbb224b90d3f0722);
function $ecc34a56e3ca8c79$export$cbb224b90d3f0722(count, min, max) {
    const numbers = [];
    while(numbers.length < count){
        const num = Math.floor(Math.random() * (max - min + 1)) + min;
        if (!numbers.includes(num)) numbers.push(num);
    }
    return numbers;
}

});

parcelRegister("9m5D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b25e149e99979c$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $lO7zi = parcelRequire("lO7zi");

var $hCdov = parcelRequire("hCdov");
class $c1b25e149e99979c$export$2e2bcd8739ae039 {
    cCoord;
    center = new (0, $lO7zi.default)("O");
    tags = [];
    constructor(cCoord, tags){
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $lO7zi.default)(tag));
        this.updateCenter();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    updateCenter = ()=>this.center.updateCoord({
            x: this.cCoord.x + 21,
            y: this.cCoord.y + 21
        });
    setAllVisible = (visible)=>[
            this.center,
            ...this.tags
        ].forEach((pTag)=>pTag.visible = visible);
    updateCoord(radians, radius) {
        const coords = (0, $hCdov.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("g4gW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d65a8310461d1d$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $i30uN = parcelRequire("i30uN");

var $3f3J1 = parcelRequire("3f3J1");
class $b0d65a8310461d1d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    AngleValue;
    arc;
    arcStroke;
    tag;
    startRadian;
    endRadian;
    degree;
    fillColor;
    smallDistance = 100;
    smallDistanceOffset = 0;
    addSmallDis = true;
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false, addSmallDis = true){
        super();
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.addSmallDis = addSmallDis;
        this.AngleValue = new (0, $i30uN.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    addArc() {
        this.arc = new $iuB9z.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $iuB9z.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $3f3J1.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $3f3J1.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $3f3J1.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("i30uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6935df93860f2c37$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $eymUv = parcelRequire("eymUv");
class $6935df93860f2c37$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color){
        super();
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Top.addChild(this);
    setValue = (value)=>this.text = `${value}\xb0`;
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $eymUv.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});
parcelRegister("eymUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afd35e271dc067b$export$2e2bcd8739ae039);
function $0afd35e271dc067b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});


parcelRegister("3f3J1", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $827e00f616855d7e$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $827e00f616855d7e$export$9340b6a85ea854b9);
function $827e00f616855d7e$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $827e00f616855d7e$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("a92Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2e4f2e6d187ae4$export$2e2bcd8739ae039);

var $2h5MD = parcelRequire("2h5MD");
function $1f2e4f2e6d187ae4$export$2e2bcd8739ae039(cCoord, coordStart, coordEnd) {
    const startRadian = (0, $2h5MD.default)(cCoord, coordStart);
    const endRadian = (0, $2h5MD.default)(cCoord, coordEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});

parcelRegister("jZEcn", function(module, exports) {

$parcel$export(module.exports, "generateAngles", () => $83c21d34517267ce$export$adec80d12bc0398e);

var $a92Ax = parcelRequire("a92Ax");

var $cwj7p = parcelRequire("cwj7p");
function $83c21d34517267ce$export$adec80d12bc0398e(p, clockwise) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
    const degree = (0, $cwj7p.default)({
        startRadian: startRadian,
        endRadian: endRadian
    }, clockwise, false);
    return {
        startRadian: startRadian,
        endRadian: endRadian,
        degree: degree
    };
}

});
parcelRegister("cwj7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6eb8af25d6ad3b0$export$2e2bcd8739ae039);

var $74Gga = parcelRequire("74Gga");
function $a6eb8af25d6ad3b0$export$2e2bcd8739ae039({ startRadian: startRadian, endRadian: endRadian }, cClockwise, even = true) {
    let _angle = startRadian - endRadian;
    if (!cClockwise) _angle = endRadian - startRadian;
    let degree = Math.floor((0, $74Gga.default)(_angle));
    degree = degree < 0 ? degree + 360 : degree;
    even && (degree = degree % 2 == 1 ? degree + 1 : degree);
    return degree;
}

});
parcelRegister("74Gga", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b402dd6b18638d$export$2e2bcd8739ae039);
function $e6b402dd6b18638d$export$2e2bcd8739ae039(radian) {
    return Math.round(radian * (180 / Math.PI));
}

});



parcelRegister("5Y8dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70362288d20b67e$export$2e2bcd8739ae039);
function $c70362288d20b67e$export$2e2bcd8739ae039(A, B, C) {
    // definate vectors
    const BA = [
        A.x - B.x,
        A.y - B.y
    ];
    const BC = [
        C.x - B.x,
        C.y - B.y
    ];
    // dot product
    const dotProduct = BA[0] * BC[0] + BA[1] * BC[1];
    // dimension of vectors
    const magnitudeBA = Math.hypot(BA[0], BA[1]);
    const magnitudeBC = Math.hypot(BC[0], BC[1]);
    // calc angles as radian
    const angleRad = Math.acos(dotProduct / (magnitudeBA * magnitudeBC));
    const angleDeg = Math.round(Number((angleRad * (180 / Math.PI)).toFixed(2)));
    return angleDeg;
}

});

parcelRegister("eitLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $295d8ae516c805d1$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");

var $gcphA = parcelRequire("gcphA");
class $295d8ae516c805d1$export$2e2bcd8739ae039 {
    CheckboxRenderer;
    isChecked = false;
    checkBoxLabel;
    handleFunc;
    constructor(coord, label, color, useCustomLayer = false, handleFunc = (label, v)=>{}){
        this.CheckboxRenderer = new (0, $gcphA.default)(color, label, useCustomLayer);
        Object.assign(this.CheckboxRenderer, coord);
        this.handleFunc = handleFunc;
        this.addInteractivity();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    addToCon = (con)=>con.addChild(this.CheckboxRenderer);
    setScale = (v)=>this.CheckboxRenderer.con.scale.set(v);
    setVisible = (v)=>this.CheckboxRenderer.visible = v;
    addInteractivity() {
        const handleUpFunc = ()=>this.handleCheckbox();
        (0, $16Wgx.default)(this.CheckboxRenderer, {
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    handleCheckbox() {
        this.isChecked = !this.isChecked;
        this.handleFunc(this.checkBoxLabel, this.isChecked);
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
    getIsChecked() {
        return {
            label: this.checkBoxLabel,
            isChecked: this.isChecked
        };
    }
    setChecked(v) {
        this.isChecked = v;
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
}

});
parcelRegister("gcphA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f182ab57cf75ac$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $c6f182ab57cf75ac$export$2e2bcd8739ae039 extends $iuB9z.Container {
    color;
    checkboxLabel;
    Layers;
    con;
    checkedSquare;
    defaultColor;
    constructor(color, checkboxLabel, useCustomLayer = false){
        super(), this.color = color, this.checkboxLabel = checkboxLabel, this.Layers = (0, $9ec1t.default).getInstance(), this.con = this.addChild(new $iuB9z.Container()), this.checkedSquare = this.con.addChild(new $iuB9z.Graphics()), this.defaultColor = 0xFFFFFF, this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.drawCheckbox(false);
        this.addLabel();
        !useCustomLayer && this.addToLayer();
    }
    addToLayer;
    drawCheckbox(isColored) {
        const fillColor = isColored ? this.color : this.defaultColor;
        this.checkedSquare.clear().roundRect(0, -20, 40, 40, 10).fill(fillColor).stroke({
            width: 2,
            color: 0x000000
        });
    }
    addLabel() {
        const text = new $iuB9z.Text({
            text: this.checkboxLabel
        });
        text.style.fontSize = 36;
        text.style.fill = this.color;
        text.anchor.set(0, .5);
        text.x = 50;
        text.y = 0;
        this.con.addChild(text);
    }
}

});


parcelRegister("gix9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4713a546dfab5e00$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $krubk = parcelRequire("krubk");

var $erVR3 = parcelRequire("erVR3");
class $4713a546dfab5e00$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    Switcher;
    Header;
    coords;
    handleFunc;
    constructor({ header: header, coords: coords, handleFunc: handleFunc }){
        super();
        this.coords = coords;
        this.handleFunc = handleFunc;
        this.addHeader(header);
        this.addCoord();
        this.addSwitcher();
        this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    setVisible = (v)=>this.visible = v;
    addToLayer = ()=>this.Layers.UI.addChild(this);
    addCoord() {
        const dim = this.Game.getDim();
        let coord = this.coords.horizontal;
        if (dim.WIDTH < dim.HEIGHT) coord = {
            x: dim.WIDTH / 2 + this.coords.vertical.x,
            y: dim.HEIGHT / 2 + this.coords.vertical.y
        };
        Object.assign(this, coord);
    }
    addHeader(header) {
        this.Header = new $iuB9z.Text({
            text: header
        });
        this.Header.anchor.set(.5);
        this.Header.x = 0;
        this.Header.y = -32;
        this.addChild(this.Header);
    }
    addSwitcher() {
        const dim = this.Game.getDim();
        this.Switcher = new (0, $krubk.default)(0x55E39F, this.handleFunc, true);
        this.Switcher.scale.set(dim.WIDTH > dim.HEIGHT ? 1.3 : 1.9);
        this.Switcher.x = 0;
        this.Switcher.y = 0;
        this.addChild(this.Switcher);
    }
    getActivationStatus = ()=>this.Switcher.getActive();
    setActivation(v) {
        const isActive = this.Switcher.getActive();
        if (v && isActive) this.Switcher.handleSwitcher(!isActive);
    }
}

});
parcelRegister("krubk", function(module, exports) {

$parcel$export(module.exports, "default", () => $621ca3294779f8aa$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $8xLbP = parcelRequire("8xLbP");

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
const $621ca3294779f8aa$var$BUTTON_X = 10;
class $621ca3294779f8aa$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    isActive = false;
    greenBg;
    grayBg;
    button;
    handleSwitch;
    constructor(color, handleSwitch, isAddCon = false){
        super();
        this.handleSwitch = handleSwitch;
        this.greenBg = this.addBg(color);
        this.grayBg = this.addBg(0xDEDEDE);
        this.addButton(0xFFFFFF);
        this.addInteractivity();
        !isAddCon && this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).closeSwitcher, ()=>this.handleSwitcherOff());
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    getActive = ()=>this.isActive;
    addBg(color) {
        const bgBound = {
            width: 40,
            height: 20
        };
        const bg = new $iuB9z.Graphics().clear().roundRect(-bgBound.width / 2, -bgBound.height / 2, bgBound.width, bgBound.height).fill(color);
        this.addChild(bg);
        return bg;
    }
    handleSwitcher(isActive) {
        this.isActive = isActive;
        this.handleSwitch(this.isActive);
        new (0, $8xLbP.default)(this);
    }
    handleSwitcherOff() {
        if (!this.isActive) return;
        this.handleSwitcher(false);
    }
    addInteractivity() {
        const handleDownFunc = ()=>this.handleSwitcher(!this.isActive);
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    setActive(v) {
        this.grayBg.alpha = this.isActive ? 1 - v : v;
        this.greenBg.alpha = this.isActive ? v : 1 - v;
        this.button.x = this.isActive ? 2 * $621ca3294779f8aa$var$BUTTON_X * v : 2 * $621ca3294779f8aa$var$BUTTON_X * (1 - v);
    }
    addButton(color) {
        this.button = new $iuB9z.Graphics().circle(-$621ca3294779f8aa$var$BUTTON_X, 0, 8).fill(color);
        this.addChild(this.button);
    }
}

});
parcelRegister("8xLbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $074e271eb87a9bab$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $074e271eb87a9bab$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Switcher){
        super();
        const alpha = 0;
        new (0, $6m47o.default).Tween({
            alpha: alpha
        }).to({
            alpha: 1
        }, 500).easing((0, $6m47o.default).Easing.Linear.None).onUpdate(({ alpha: alpha })=>{
            Switcher.setActive(alpha);
        }).start();
    }
}

});



parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $75RpY = parcelRequire("75RpY");

var $iiVV4 = parcelRequire("iiVV4");

var $fGH3X = parcelRequire("fGH3X");

var $3DpJv = parcelRequire("3DpJv");

var $5ehzb = parcelRequire("5ehzb");
const $5be887b5ccefa13b$export$64436d1175f556d9 = {
    angle1: "a",
    angle2: "b",
    angle3: "c",
    angle4: "d"
};
const $5be887b5ccefa13b$export$853e2ffa6cb8f5fa = [
    0xFC99C4,
    0x21D4FE,
    0xf94f6f,
    0x0195b8
];
const $5be887b5ccefa13b$export$ca8f2c484d507a5d = 200;
const $5be887b5ccefa13b$export$6d492146c93bd459 = [
    Math.PI / 18 * 13,
    Math.PI / 9 * 2,
    -Math.PI / 9,
    -Math.PI / 6 * 5
];
const $5be887b5ccefa13b$export$c7609d9da8d80867 = {
    x: 600,
    y: 310
};
const $5be887b5ccefa13b$export$186dbbe504e85fe1 = [
    {
        x: 420,
        y: 800
    },
    {
        x: 810,
        y: 800
    }
];
const $5be887b5ccefa13b$export$75f2cc8245aafe09 = [
    {
        x: 60,
        y: 400
    },
    {
        x: 60,
        y: 400
    }
];
const $5be887b5ccefa13b$export$1312ecbb29a79419 = {
    x: 195,
    y: 800
};
const $5be887b5ccefa13b$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $5be887b5ccefa13b$export$190b4c043fb6edf4 = {
    x: 1500,
    y: 800
};
const $5be887b5ccefa13b$export$f64a627e96c12fc8 = [
    {
        x: 750,
        y: 620
    },
    {
        x: 750,
        y: 670
    }
];
const $5be887b5ccefa13b$export$2e51dc0dfab2d766 = "circle-theorem-2";
const $5be887b5ccefa13b$export$619d8bee3d0fdc47 = [
    [
        {
            x: 40,
            y: 400
        },
        {
            x: 40,
            y: 350
        },
        {
            x: 100,
            y: 400
        },
        {
            x: 100,
            y: 350
        }
    ],
    [
        {
            x: 200,
            y: 400
        },
        {
            x: 200,
            y: 350
        },
        {
            x: 200,
            y: 400
        },
        {
            x: 200,
            y: 350
        }
    ]
];



var $iuB9z = parcelRequire("iuB9z");
var $497cd17e3d6f7072$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["setCalcLines"] = "SET_CALC_LINES";
    EnumEventBus["showCalcLine"] = "SHOW_CALCULATION_LINE";
    EnumEventBus["setGrowCircleValue"] = "SET_GROW_CIRCLE_VALUE";
    EnumEventBus["setCentralValue"] = "SET_CENTRAL_SLIDER_VALUE";
    EnumEventBus["setRotCircleValue"] = "SET_ROTATE_CIRCLE_VALUE";
    EnumEventBus["setRadiansToRefs"] = "SET_RADIAN_PARAMS_TO_RADIAN_REFERANCE_PARAMS";
    EnumEventBus["setCalcForAnim"] = "SET_CALCULATION_LINE_FOR_ANIMATION";
    EnumEventBus["showSliders"] = "SHOW_SLIDERS";
    EnumEventBus["drawElements"] = "DRAW_ELEMENTS";
    EnumEventBus["generateRandomQuadri"] = "GENERATE_RANDOM_QUADRILATERAL";
    EnumEventBus["movePoints"] = "MOVE_POINTS";
    EnumEventBus["supplementaryMode"] = "SUPPLEMENTARY_MODE";
    EnumEventBus["setElementsForAnim"] = "SET_ELEMENTS_FOR_ANIMATION";
    EnumEventBus["setPointChecklist"] = "SET_POINT_CHECK_LIST";
    return EnumEventBus;
}({});
const $497cd17e3d6f7072$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();



var $1B2xl = parcelRequire("1B2xl");

var $iD90R = parcelRequire("iD90R");

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $f6976063e5aeb533$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    onUpdate;
    resolve;
    constructor(sAngle, onUpdate, onComp, resolve){
        super();
        const d = 800;
        const angle = Math.PI / 12;
        this.onUpdate = onUpdate;
        this.resolve = resolve;
        this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, ()=>this.isStopped = true);
        if (this.Anim.getIsCancelled()) {
            this.resolve();
            return;
        }
        this.moveRedPoint(sAngle, angle, d, ()=>{
            this.moveRedPoint(sAngle + angle, -angle * 2, d * 2, ()=>{
                this.moveRedPoint(sAngle - angle, angle, d, ()=>onComp());
            });
        });
    }
    moveRedPoint(sAngle, angle, duration, onComp) {
        if (this.Anim.getIsCancelled()) {
            this.resolve();
            return;
        }
        const a = {
            angle: sAngle
        };
        new (0, $6m47o.default).Tween({
            ...a
        }).to({
            angle: sAngle + angle
        }, duration).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((a)=>{
            if (this.isStopped) {
                onComp();
                return;
            }
            this.onUpdate(a.angle);
        }).onComplete(()=>onComp()).start();
    }
}



var $kSVlj = parcelRequire("kSVlj");
function $ff432775c345a26d$export$2f626a9a8b571038(calcLine) {
    const onUpdate = (v)=>calcLine.scale.set(v);
    calcLine.visible = true;
    onUpdate(.4);
    return new Promise(()=>new (0, $kSVlj.default)(.4, 1, (v)=>onUpdate(v)));
}
function $ff432775c345a26d$export$9f98a19940c75aef(supplAngleLine) {
    const onUpdate = (v)=>supplAngleLine.scale.set(v);
    supplAngleLine.visible = true;
    onUpdate(.4);
    return new Promise(()=>new (0, $kSVlj.default)(.4, 1, (v)=>onUpdate(v)));
}
function $ff432775c345a26d$export$6f65ac6ef713080a(startRadian, callback) {
    return new Promise((resolve)=>{
        new (0, $f6976063e5aeb533$export$2e2bcd8739ae039)(startRadian, callback, resolve, resolve);
    });
}



async function $84ac9c7fd3c3a091$export$2721aded6352b5ea(context, onComp) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager, SupplAngleManager: SupplAngleManager, CalcLineManager: CalcLineManager, cCoord: cCoord } = context;
    const [cSide1Point, cSide2Point, cSide3Point, cSide4Point] = PointManager.getRedPointsCoord();
    const RedPoints = PointManager.getRedPoints();
    const circlePoint = PointManager.getPoints()[0];
    const radians = PointManager.getRadians();
    const angles = AngleManager.getAngles();
    circle.setRadians([
        (0, $5be887b5ccefa13b$export$6d492146c93bd459)[0],
        (0, $5be887b5ccefa13b$export$6d492146c93bd459)[0]
    ]);
    await (0, $iD90R.drawPointsAnim)([
        circlePoint
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $5be887b5ccefa13b$export$6d492146c93bd459)[0] + Math.PI * 2, 0, true, cCoord);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[0], cSide1Point, cSide2Point);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[1], cSide2Point, cSide3Point);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[2], cSide3Point, cSide4Point);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[3], cSide4Point, cSide1Point);
    (0, $iD90R.drawAngleAnim)(angles[0], (0, $5be887b5ccefa13b$export$64436d1175f556d9).angle1);
    await (0, $iD90R.drawAngleAnim)(angles[2], (0, $5be887b5ccefa13b$export$64436d1175f556d9).angle3);
    (0, $ff432775c345a26d$export$2f626a9a8b571038)(CalcLineManager.firstCalcLine);
    (0, $iD90R.drawAngleAnim)(angles[1], (0, $5be887b5ccefa13b$export$64436d1175f556d9).angle2);
    await (0, $iD90R.drawAngleAnim)(angles[3], (0, $5be887b5ccefa13b$export$64436d1175f556d9).angle4);
    (0, $ff432775c345a26d$export$2f626a9a8b571038)(CalcLineManager.secondCalcLine);
    await (0, $iD90R.drawPointsAnim)(RedPoints);
    for(let index = 0; index < 2; index++){
        (0, $ff432775c345a26d$export$6f65ac6ef713080a)(radians[index], (radian)=>PointManager.setRadian([
                {
                    pTag: RedPoints[index].tag,
                    radian: radian
                }
            ]));
        await (0, $ff432775c345a26d$export$6f65ac6ef713080a)(radians[index + 2], (radian)=>PointManager.setRadian([
                {
                    pTag: RedPoints[index + 2].tag,
                    radian: radian
                }
            ]));
    }
    const pointAnimArr = [
        [
            -(2 * Math.PI) * 15 / 36,
            -(2 * Math.PI) * 3 / 36,
            -(2 * Math.PI) * 7 / 36,
            -(2 * Math.PI) * 10 / 36
        ],
        [
            2 * Math.PI * 10.5 / 36,
            2 * Math.PI * 6 / 36,
            2 * Math.PI * 3.5 / 36,
            2 * Math.PI * 17 / 36
        ],
        PointManager.getInitialRadians()
    ];
    for(let index = 0; index < pointAnimArr.length; index++){
        const arr = pointAnimArr[index];
        await (0, $iD90R.moveAllPointAnim)(radians, arr, (radian, index)=>PointManager.setRadian([
                {
                    pTag: RedPoints[index].tag,
                    radian: radian
                }
            ]));
    }
    (0, $ff432775c345a26d$export$9f98a19940c75aef)(SupplAngleManager.SupplAngleLines[0]);
    (0, $ff432775c345a26d$export$9f98a19940c75aef)(SupplAngleManager.SupplAngleLines[1]);
    onComp();
}
function $84ac9c7fd3c3a091$export$220c3d2061e74c52(PointManager, radians, newRadians) {
    const RedPoints = PointManager.getRedPoints();
    (0, $iD90R.moveAllPointAnim)(radians, newRadians, (radian, index)=>PointManager.setRadian([
            {
                pTag: RedPoints[index].tag,
                radian: radian
            }
        ]));
}


function $8ca641ecf4294fbb$export$4777bb8a9f19b87(PointManager, radians) {
    const newRadians = (0, $1B2xl.getRandomUniqueNumbers)(4, 0, 11).map((v)=>v * (Math.PI / 6)).sort().reverse();
    (0, $84ac9c7fd3c3a091$export$220c3d2061e74c52)(PointManager, radians, newRadians);
}


class $19e42c2d00c5ddae$export$2e2bcd8739ae039 extends (0, $5ehzb.default) {
    pointCheckList = [];
    constructor(){
        super((0, $5be887b5ccefa13b$export$c7609d9da8d80867), (0, $5be887b5ccefa13b$export$ca8f2c484d507a5d), (0, $5be887b5ccefa13b$export$6d492146c93bd459));
        this.setCoord();
        this.draw();
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).setPointChecklist, (l)=>this.pointCheckList = l);
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).generateRandomQuadri, ()=>this.generateRandomShape());
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).setGrowCircleValue, (v)=>this.setGrowCircle(v));
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).movePoints, (v)=>this.movePoints(v));
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).setRadiansToRefs, ()=>this.pointRefRadians = [
                ...this.pointRadians
            ]);
    }
    generateRandomShape = ()=>(0, $8ca641ecf4294fbb$export$4777bb8a9f19b87)(this, this.getRadians());
    setGrowCircle(v) {
        this.circleRadius = v / 5 + (0, $5be887b5ccefa13b$export$ca8f2c484d507a5d);
        this.setCoord();
    }
    movePoints = (v)=>{
        const points = this.getRedPoints();
        const generateOffsetRadian = (v)=>Math.PI / 300 * v;
        const pointInfoArr = this.pointCheckList.map((e, eI)=>this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0)).map((r, rI)=>({
                pTag: points[rI].tag,
                radian: r
            }));
        this.setRadian(pointInfoArr, true);
    };
}



var $9m5D8 = parcelRequire("9m5D8");
class $593a5621353877dc$export$2e2bcd8739ae039 extends (0, $9m5D8.default) {
    constructor(cCoord){
        super(cCoord, [
            "A",
            "B",
            "C",
            "D"
        ]);
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $erVR3 = parcelRequire("erVR3");

function $a38d653b19a7f215$export$2e2bcd8739ae039(pStart, pEnd, length) {
    const angle = Math.atan2(pStart.y - pEnd.y, pStart.x - pEnd.x);
    const p = {
        x: pStart.x + Math.cos(angle) * length,
        y: pStart.y + Math.sin(angle) * length
    };
    return [
        pStart,
        p
    ];
}


class $600b65abf76d6aa0$export$2e2bcd8739ae039 {
    isSuppMode = false;
    lines = Array(4).fill("").map((_)=>new (0, $d0yDD.default)());
    guideLine1 = new (0, $d0yDD.default)({
        width: 3
    });
    guideLine2 = new (0, $d0yDD.default)({
        width: 3
    });
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.clearAll());
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).supplementaryMode, (v)=>this.isSuppMode = v);
    }
    clearAll = ()=>[
            ...this.lines,
            this.guideLine1,
            this.guideLine2
        ].forEach((l)=>l.clear());
    draw([p1, p2, p3, p4]) {
        this.drawLines([
            p1,
            p2,
            p3,
            p4
        ]);
        this.isSuppMode && this.drawGuideLines([
            p1,
            p2,
            p3,
            p4
        ]);
    }
    drawLines(points) {
        const getSecCoord = (li)=>points[li + 1 !== this.lines.length ? li + 1 : 0];
        this.lines.forEach((l, li)=>l.draw(points[li], getSecCoord(li)));
    }
    drawGuideLines([p1, p2, p3, p4]) {
        const gl1 = (0, $a38d653b19a7f215$export$2e2bcd8739ae039)(p2, p3, 120);
        const gl2 = (0, $a38d653b19a7f215$export$2e2bcd8739ae039)(p3, p2, 120);
        this.guideLine1.draw(gl1[0], gl1[1]);
        this.guideLine2.draw(gl2[0], gl2[1]);
    }
    getGuideLinesCoords([p1, p2, p3, p4]) {
        return [
            (0, $a38d653b19a7f215$export$2e2bcd8739ae039)(p2, p3, 120),
            (0, $a38d653b19a7f215$export$2e2bcd8739ae039)(p3, p2, 120)
        ];
    }
}



var $erVR3 = parcelRequire("erVR3");


var $g4gW0 = parcelRequire("g4gW0");


var $eP48i = parcelRequire("eP48i");


var $a92Ax = parcelRequire("a92Ax");

var $jZEcn = parcelRequire("jZEcn");
function $cd8015c3d4aca283$export$73935091fa556468(angle, p, degree, clockwise) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
    const smllDistance = Math.min((0, $eP48i.default)(p.curr, p.prev), (0, $eP48i.default)(p.curr, p.next));
    angle.smallDistance = Math.floor(smllDistance);
    angle.draw(p.curr, startRadian, endRadian, degree, clockwise);
    angle.x = p.curr.x;
    angle.y = p.curr.y;
    angle.rotation = 0;
}
function $cd8015c3d4aca283$export$39ecf6e52a70201b(supplAngle, p, degree, clockwise, isFirst) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
    $cd8015c3d4aca283$export$73935091fa556468(supplAngle, p, degree, clockwise);
    supplAngle.x = supplAngle.coord.x;
    supplAngle.y = supplAngle.coord.y;
    supplAngle.AngleValue.visible = false;
    supplAngle.rotation = isFirst ? Math.PI - startRadian : 0 - endRadian;
}
function $cd8015c3d4aca283$export$ad3ca434770b077d(angle1, angle4, degrees, [p1, p2, p3, p4], clockwise) {
    const points = (0, $a38d653b19a7f215$export$2e2bcd8739ae039)(p3, p2, 200);
    const points1 = (0, $a38d653b19a7f215$export$2e2bcd8739ae039)(p2, p3, 200);
    const p = {
        curr: p3,
        prev: p4,
        next: points[1]
    };
    const pt1 = {
        curr: p2,
        prev: p1,
        next: points1[1]
    };
    const anglef = (0, $jZEcn.generateAngles)(p, clockwise);
    const angles = (0, $jZEcn.generateAngles)(pt1, clockwise);
    $cd8015c3d4aca283$export$73935091fa556468(angle1, p, degrees[0], clockwise);
    $cd8015c3d4aca283$export$73935091fa556468(angle4, pt1, degrees[1], !clockwise);
}


function $77c2578a3523d273$export$5f61282e9abe72d5(pointArr) {
    return pointArr.map((p, pI)=>{
        const prevP = pointArr[pI == 0 ? pointArr.length - 1 : pI - 1];
        const nextP = pointArr[pI == pointArr.length - 1 ? 0 : pI + 1];
        return {
            curr: p,
            prev: prevP,
            next: nextP
        };
    });
}



var $5Y8dU = parcelRequire("5Y8dU");
class $79a59466696ba8ab$export$2e2bcd8739ae039 {
    angles = (0, $5be887b5ccefa13b$export$853e2ffa6cb8f5fa).map((color, colorI)=>new (0, $g4gW0.default)(`a${colorI + 1}`, {
            color: color,
            textColor: color
        }, 44));
    isSuppMode = false;
    currAngles = [];
    constructor(){
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).supplementaryMode, (v)=>this.isSuppMode = v);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    emitAngles = (degrees)=>(0, $497cd17e3d6f7072$export$f6644f0f2c90144b).emit((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).setCalcLines, degrees);
    getAngles = ()=>this.angles;
    drawGuideAngle = (pArr, degrees)=>(0, $cd8015c3d4aca283$export$ad3ca434770b077d)(this.angles[0], this.angles[3], degrees, pArr, false);
    setAllVisible = (v)=>this.angles.forEach((angle)=>angle.setVisible(v));
    draw(pointArr, clockwise) {
        const points = (0, $77c2578a3523d273$export$5f61282e9abe72d5)(pointArr);
        const angle1 = (0, $5Y8dU.default)(points[0].prev, points[0].curr, points[0].next);
        const angle2 = (0, $5Y8dU.default)(points[1].prev, points[1].curr, points[1].next);
        const degrees = [
            angle1,
            angle2,
            180 - angle1,
            180 - angle2
        ];
        points.forEach((p, pI)=>(0, $cd8015c3d4aca283$export$73935091fa556468)(this.angles[pI], p, degrees[pI], clockwise));
        this.isSuppMode && this.drawGuideAngle(pointArr, [
            degrees[0],
            degrees[3]
        ]);
        this.emitAngles(Array(4).fill(null).map((_, i)=>degrees[i]));
    }
}



var $75RpY = parcelRequire("75RpY");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $g4gW0 = parcelRequire("g4gW0");
class $b863eda94716606c$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    supplAngles = [];
    constructor(coord, tags, colors){
        super();
        Object.assign(this, coord);
        this.addAngles(colors, tags);
        this.addSymbols();
        this.addToLayer();
    }
    getSupplAngle = ()=>this.supplAngles;
    addToLayer = ()=>this.Layers.Info.addChild(this);
    setVisible = (v)=>{
        this.visible = v;
        this.supplAngles.forEach((angle)=>angle.visible = v);
    };
    addAngles(colors, tags) {
        this.supplAngles = [
            -70,
            0,
            100,
            100
        ].map((x, xI)=>{
            const sAngle = new $b863eda94716606c$export$ab9a537db157d0c5({
                x: x,
                y: 0
            }, tags[xI], colors[xI % 2]);
            this.addChild(sAngle);
            return sAngle;
        });
    }
    addSymbols() {
        const xs = [
            -30,
            50
        ];
        const symbols = [
            "+",
            "="
        ].map((t, tI)=>{
            const text = new $iuB9z.Text({
                text: t
            });
            text.style.fontSize = 35;
            text.x = xs[tI];
            text.anchor.set(.5, .8);
            this.addChild(text);
            return text;
        });
    }
}
class $b863eda94716606c$export$ab9a537db157d0c5 extends (0, $g4gW0.default) {
    coord;
    constructor(coord, tag, color){
        super(tag, {
            color: color,
            textColor: 0x000000
        }, -100, true);
        this.coord = coord;
        this.scale.set(.5);
    }
}



var $erVR3 = parcelRequire("erVR3");



var $jZEcn = parcelRequire("jZEcn");

class $562fc195b45cc3fe$export$2e2bcd8739ae039 {
    Game = (0, $75RpY.default).getInstance();
    SupplAngleLines = [];
    SupplAngles = [];
    SupplAnglesTotal = [];
    constructor(){
        this.addSupplAngles();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    setAllVisible = (v)=>this.SupplAngleLines.forEach((l)=>l.setVisible(v));
    isVertical() {
        const dim = this.Game.getDim();
        return dim.WIDTH < dim.HEIGHT;
    }
    generateCoords() {
        const isVertical = this.isVertical();
        const dim = this.Game.getDim();
        let coords = [
            {
                x: 150,
                y: 350
            },
            {
                x: 150,
                y: 400
            }
        ];
        if (isVertical) coords = [
            {
                x: dim.WIDTH / 2 - 215,
                y: dim.HEIGHT / 2 + 250
            },
            {
                x: dim.WIDTH / 2 + 185,
                y: dim.HEIGHT / 2 + 250
            }
        ];
        return coords;
    }
    addSupplAngles() {
        const coords = this.generateCoords();
        const l1 = new (0, $b863eda94716606c$export$2e2bcd8739ae039)(coords[0], [
            "sa-1",
            "sa-3",
            "sat-1",
            "sat-3"
        ], [
            (0, $5be887b5ccefa13b$export$853e2ffa6cb8f5fa)[0],
            (0, $5be887b5ccefa13b$export$853e2ffa6cb8f5fa)[2]
        ]);
        const l2 = new (0, $b863eda94716606c$export$2e2bcd8739ae039)(coords[1], [
            "sa-2",
            "sa-4",
            "sat-2",
            "sat-4"
        ], [
            (0, $5be887b5ccefa13b$export$853e2ffa6cb8f5fa)[1],
            (0, $5be887b5ccefa13b$export$853e2ffa6cb8f5fa)[3]
        ]);
        const angles = [
            l1.getSupplAngle(),
            l2.getSupplAngle()
        ];
        this.SupplAngleLines = [
            l1,
            l2
        ];
        this.SupplAngles = [
            angles[0][0],
            angles[1][0],
            angles[0][1],
            angles[1][1]
        ];
        this.SupplAnglesTotal = [
            angles[0][2],
            angles[1][2],
            angles[0][3],
            angles[1][3]
        ];
    }
    draw(pointArr, clockwise) {
        const points = (0, $77c2578a3523d273$export$5f61282e9abe72d5)(pointArr);
        const degree1 = (0, $jZEcn.generateAngles)(points[0], clockwise).degree;
        const degree2 = (0, $jZEcn.generateAngles)(points[1], clockwise).degree;
        const degrees = [
            degree1,
            degree2,
            180 - degree1,
            180 - degree2
        ];
        pointArr.forEach((p, pI)=>{
            const prevP = pointArr[pI == 0 ? pointArr.length - 1 : pI - 1];
            const nextP = pointArr[pI == pointArr.length - 1 ? 0 : pI + 1];
            (0, $cd8015c3d4aca283$export$39ecf6e52a70201b)(this.SupplAngles[pI], {
                curr: p,
                prev: prevP,
                next: nextP
            }, degrees[pI], clockwise, pI < 2);
            (0, $cd8015c3d4aca283$export$39ecf6e52a70201b)(this.SupplAnglesTotal[pI], {
                curr: p,
                prev: prevP,
                next: nextP
            }, degrees[pI], clockwise, pI < 2);
        });
    }
}



var $erVR3 = parcelRequire("erVR3");



var $e8wW1 = parcelRequire("e8wW1");

class $b8a34e639abcb296$export$2e2bcd8739ae039 {
    PointManager;
    AngleManager;
    SupplAngleManager;
    LineManager;
    CalcLineManager;
    circle;
    cCoord;
    isSwitcherActive;
    constructor(PointManager, AngleManager, SupplAngleManager, LineManager, CalcLineManager, circle, cCoord){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.SupplAngleManager = SupplAngleManager;
        this.LineManager = LineManager;
        this.CalcLineManager = CalcLineManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.isSwitcherActive = false;
        this.getDelayForStartAnim = ()=>this.isSwitcherActive ? 4000 : 0;
        this.addCircAnimBut = ()=>new (0, $e8wW1.default)((0, $5be887b5ccefa13b$export$840ec2322406bfdd), ()=>this.runAnimations(), ()=>this.getDelayForStartAnim());
        this.drawAngles = (rPointsCoord, isbtw)=>this.AngleManager.draw(rPointsCoord, isbtw);
        this.drawAngles(this.PointManager.getRedPointsCoord(), false);
        this.addCircAnimBut();
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).supplementaryMode, (v)=>this.isSwitcherActive = v);
    }
    getDelayForStartAnim;
    addCircAnimBut;
    drawAngles;
    runAnimations() {
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).emit((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).setElementsForAnim, false);
        const context = {
            circle: this.circle,
            AngleManager: this.AngleManager,
            PointManager: this.PointManager,
            LineManager: this.LineManager,
            SupplAngleManager: this.SupplAngleManager,
            CalcLineManager: this.CalcLineManager,
            cCoord: this.cCoord
        };
        (0, $84ac9c7fd3c3a091$export$2721aded6352b5ea)(context, ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
        });
    }
}



var $75RpY = parcelRequire("75RpY");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $6aa426e01b4ffbee$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color, initialVals){
        super();
        Object.assign(this, coord);
        this.addText(color);
        this.text = `${initialVals[0]}\xb0 + ${initialVals[1]}\xb0 = 180\xb0`;
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Info.addChild(this);
    generateText = (degree1, degree2)=>`${degree1}\xb0 + ${degree2}\xb0 ${degree1 + degree2 == 180 ? "=" : "\u2260"} 180\xb0`;
    addText(color) {
        this.text = "x\xb0 + y\xb0 = 180\xb0";
        this.style.fontWeight = "600";
        this.style.fill = color;
        this.style.fontSize = 40;
        this.anchor.set(1);
    }
    updateDegrees(degree1, degree2) {
        this.text = this.generateText(degree1, degree2);
    }
}



var $3ANoO = parcelRequire("3ANoO");


var $erVR3 = parcelRequire("erVR3");

class $ea241116ff1cc1b8$export$2e2bcd8739ae039 {
    Game = (0, $75RpY.default).getInstance();
    isCompletedCircleAnim = true;
    firstCalcLine;
    secondCalcLine;
    constructor(isVertical){
        this.generateCalcLines(isVertical);
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).setCalcLines, (degrees)=>this.setDegrees(degrees));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.isCompletedCircleAnim = true);
    }
    generateCalcLines(isVertical) {
        const dim = this.Game.getDim();
        const verticalCoords = [
            {
                x: dim.WIDTH / 2 - 50,
                y: dim.HEIGHT / 2 + 200
            },
            {
                x: dim.WIDTH / 2 + 350,
                y: dim.HEIGHT / 2 + 200
            }
        ];
        const coords = isVertical ? verticalCoords : (0, $5be887b5ccefa13b$export$f64a627e96c12fc8);
        this.firstCalcLine = new (0, $6aa426e01b4ffbee$export$2e2bcd8739ae039)(coords[0], (0, $3ANoO.CENTER_ANGLE_COLOR).textColor, [
            "a",
            "c"
        ]);
        this.secondCalcLine = new (0, $6aa426e01b4ffbee$export$2e2bcd8739ae039)(coords[1], (0, $3ANoO.CIRCUM_ANGLE_COLOR).textColor, [
            "b",
            "d"
        ]);
    }
    setDegrees(degrees) {
        if (!this.isCompletedCircleAnim) return;
        this.firstCalcLine.updateDegrees(degrees[0], degrees[2]);
        this.secondCalcLine.updateDegrees(degrees[1], degrees[3]);
    }
    setAllVisible(v) {
        this.firstCalcLine.visible = v;
        this.secondCalcLine.visible = v;
    }
    setVisible(index, v) {
        if (index == 0) this.firstCalcLine.visible = v;
        else if (index == 1) this.secondCalcLine.visible = v;
    }
}



var $b2sIL = parcelRequire("b2sIL");


var $eitLW = parcelRequire("eitLW");

const $3bfd9d882f819897$var$SliderGen = [
    {
        head: "grow shape",
        colors: {
            bgColor: 0x21D4FE,
            barColor: 0x000000,
            buttonColor: 0x21D4FE
        },
        keepCurrSlider: true,
        onUpdate: (v)=>(0, $497cd17e3d6f7072$export$f6644f0f2c90144b).emit((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).setGrowCircleValue, v - 100)
    },
    {
        head: "move the points",
        subHead: "(select which one to use)",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $497cd17e3d6f7072$export$f6644f0f2c90144b).emit((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).movePoints, v - 100)
    }
];
const $3bfd9d882f819897$var$pointName = [
    "Point A",
    "Point B",
    "Point C",
    "Point D"
];
class $3bfd9d882f819897$export$2e2bcd8739ae039 extends (0, $b2sIL.default) {
    pointCheckboxs = [];
    pointChecklist = Array(4).fill(false);
    constructor(){
        super($3bfd9d882f819897$var$SliderGen, (0, $5be887b5ccefa13b$export$186dbbe504e85fe1), (0, $5be887b5ccefa13b$export$75f2cc8245aafe09));
        this.checkVertical();
        this.addCheckBoxs();
    }
    checkVertical() {
        if (this.dim.WIDTH < this.dim.HEIGHT) {
            const slider = this.sliders[0];
            this.sliders.shift();
            slider.setSliderVisible(false);
        }
    }
    handleCheckbox(index, v) {
        this.pointChecklist[index] = v;
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).emit((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).setPointChecklist, this.pointChecklist);
    }
    addCheckBoxs() {
        const coords = $3bfd9d882f819897$var$getPointCheckboxCoords(this.dim);
        this.pointCheckboxs = (0, $5be887b5ccefa13b$export$853e2ffa6cb8f5fa).map((e, eI)=>new (0, $eitLW.default)(coords[eI], $3bfd9d882f819897$var$pointName[eI], e, false, (label, v)=>this.handleCheckbox(eI, v)));
        this.dim.WIDTH < this.dim.HEIGHT && this.pointCheckboxs.forEach((cbox)=>cbox.setScale(.8));
    }
}
function $3bfd9d882f819897$var$getPointCheckboxCoords(dim) {
    const getCoordHorizontal = (eI)=>({
            x: 1165 + (eI > 1 ? 180 : 0),
            y: 775 + (eI % 2 == 1 ? 50 : 0)
        });
    const getCoordVertical = (eI)=>({
            x: dim.WIDTH / 2 + 35 + (eI > 1 ? 150 : 0),
            y: dim.HEIGHT / 2 + 500 + (eI % 2 == 1 ? 40 : 0)
        });
    const coords = Array(4).fill(null).map((e, eI)=>dim.WIDTH > dim.HEIGHT ? getCoordHorizontal(eI) : getCoordVertical(eI));
    return coords;
}




var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $bea4d34da5c963f8$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    pCoord;
    sCoord;
    tCoord;
    constructor(Line, pCoord, sCoord, tCoord, onComp){
        super(), this.pCoord = pCoord, this.sCoord = sCoord, this.tCoord = tCoord;
        new (0, $6m47o.default).Tween({
            ...sCoord
        }).to({
            x: tCoord.x,
            y: tCoord.y
        }, 1000).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((coord)=>{
            Line.draw(pCoord, coord);
        }).onComplete(()=>onComp()).start();
    }
}



var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $544ec64cdfebbfe0$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Angle, tCoord, onComp = ()=>{}){
        super();
        new (0, $6m47o.default).Tween(Angle).to(tCoord, 1200).easing((0, $6m47o.default).Easing.Linear.None).onComplete(()=>onComp()).start();
    }
}



var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $299d5a35ee306574$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Point, visible, onComp){
        super();
        const tS = visible ? 1 : .3;
        visible && (Point.visible = true);
        new (0, $6m47o.default).Tween(Point.scale).to({
            x: tS,
            y: tS
        }, 300).easing((0, $6m47o.default).Easing.Linear.None).onComplete(()=>{
            Point.visible = visible;
            onComp();
        }).start();
    }
}



var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $ef3664eff8156c61$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(angle, rotation, delay, onComp){
        super();
        new (0, $6m47o.default).Tween(angle).to({
            rotation: rotation
        }, 500).delay(delay).onComplete(()=>onComp()).start();
    }
}


function $3d2ffac2e2b8c700$export$3a775ef3f2639103(pointArr, visible) {
    return new Promise((resolve)=>{
        pointArr.forEach((point)=>{
            point.visible = true;
            point.scale = 0.2;
            new (0, $299d5a35ee306574$export$2e2bcd8739ae039)(point, visible, ()=>resolve());
        });
    });
}
function $3d2ffac2e2b8c700$export$74d7a69a4127e6bc(guideLines, lC, isReverse) {
    return new Promise((resolve)=>{
        guideLines.forEach((guideLine, gI)=>{
            const pCoord = lC[gI][0];
            const sCoord = isReverse ? lC[gI][1] : lC[gI][0];
            const tCoord = isReverse ? lC[gI][0] : lC[gI][1];
            new (0, $bea4d34da5c963f8$export$2e2bcd8739ae039)(guideLine, pCoord, sCoord, tCoord, ()=>resolve());
        });
    });
}
function $3d2ffac2e2b8c700$export$650c6fb8e1a8ad1a(angles, points) {
    return new Promise((resolve)=>{
        angles.forEach((angle, aI)=>{
            new (0, $544ec64cdfebbfe0$export$2e2bcd8739ae039)(angle, points[aI], ()=>resolve());
        });
    });
}
function $3d2ffac2e2b8c700$export$cc31dc8840bfd545(angles, rotations) {
    return new Promise((resolve)=>{
        angles.forEach((angle, aI)=>{
            new (0, $ef3664eff8156c61$export$2e2bcd8739ae039)(angle, rotations[aI], 300, ()=>resolve());
        });
    });
}


function $8f7ad0c31217b9ef$export$17da8f6ce3aa1c5d(context, isActive) {
    isActive ? $8f7ad0c31217b9ef$export$84387efe5e3837ca(context) : $8f7ad0c31217b9ef$export$d64178aba196494(context);
}
async function $8f7ad0c31217b9ef$export$84387efe5e3837ca(context) {
    const { LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager } = context;
    const redPoints = PointManager.getRedPoints();
    const pointCoords = redPoints.map((r)=>({
            x: r.x,
            y: r.y
        }));
    const angles = AngleManager.getAngles();
    const lC = LineManager.getGuideLinesCoords(pointCoords);
    const rots = [
        -Math.PI / 180 * angles[3].degree,
        Math.PI / 180 * angles[0].degree
    ];
    await (0, $3d2ffac2e2b8c700$export$3a775ef3f2639103)([
        redPoints[0],
        redPoints[3]
    ], false);
    await (0, $3d2ffac2e2b8c700$export$74d7a69a4127e6bc)([
        LineManager.guideLine1,
        LineManager.guideLine2
    ], lC, false);
    await (0, $3d2ffac2e2b8c700$export$650c6fb8e1a8ad1a)([
        angles[0],
        angles[3]
    ], [
        pointCoords[2],
        pointCoords[1]
    ]);
    await (0, $3d2ffac2e2b8c700$export$cc31dc8840bfd545)([
        angles[0],
        angles[3]
    ], rots);
}
async function $8f7ad0c31217b9ef$export$d64178aba196494(context) {
    const { LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager } = context;
    const redPoints = PointManager.getRedPoints();
    const pointCoords = redPoints.map((r)=>({
            x: r.x,
            y: r.y
        }));
    const angles = AngleManager.getAngles();
    const lC = LineManager.getGuideLinesCoords(pointCoords);
    const _rots = [
        -Math.PI / 180 * angles[3].degree,
        Math.PI / 180 * angles[0].degree
    ];
    const rots = angles[0].rotation == 0 && angles[3].rotation == 0 ? _rots : [
        0,
        0
    ];
    await (0, $3d2ffac2e2b8c700$export$650c6fb8e1a8ad1a)([
        angles[0],
        angles[3]
    ], [
        pointCoords[0],
        pointCoords[3]
    ]);
    await (0, $3d2ffac2e2b8c700$export$cc31dc8840bfd545)([
        angles[0],
        angles[3]
    ], rots);
    await (0, $3d2ffac2e2b8c700$export$74d7a69a4127e6bc)([
        LineManager.guideLine1,
        LineManager.guideLine2
    ], lC, true);
    await (0, $3d2ffac2e2b8c700$export$3a775ef3f2639103)([
        redPoints[0],
        redPoints[3]
    ], true);
}


class $24aace51740879bb$export$2e2bcd8739ae039 {
    PointManager;
    AngleManager;
    LineManager;
    animated;
    constructor(PointManager, AngleManager, LineManager){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.LineManager = LineManager;
        this.animated = false;
        (0, $497cd17e3d6f7072$export$f6644f0f2c90144b).on((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).supplementaryMode, (v)=>this.runAnimation(v));
    }
    runAnimation(isActive) {
        const context = {
            PointManager: this.PointManager,
            LineManager: this.LineManager,
            AngleManager: this.AngleManager
        };
        (0, $8f7ad0c31217b9ef$export$17da8f6ce3aa1c5d)(context, isActive);
    }
}



var $erVR3 = parcelRequire("erVR3");

var $gix9M = parcelRequire("gix9M");

class $37e377a4bc959501$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: "Supplementary Visual",
            coords: {
                vertical: {
                    x: -200,
                    y: 560
                },
                horizontal: {
                    x: 160,
                    y: 300
                }
            },
            handleFunc: (v)=>(0, $497cd17e3d6f7072$export$f6644f0f2c90144b).emit((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).supplementaryMode, v)
        });
    }
}



var $75RpY = parcelRequire("75RpY");

var $llFKB = parcelRequire("llFKB");


var $erVR3 = parcelRequire("erVR3");

const $2690ab5c7d68bfba$var$ButtonStyle = {
    width: 280,
    height: 120,
    wordWrapWidth: 160,
    defaultColor: 0xCECECE,
    hoverColor: 0xDEDEDE,
    pressedColor: 0xC5C5C5,
    borderColor: 0x111111,
    titleColor: 0x111111,
    titleFontSize: 28,
    borderRadius: 22
};
class $2690ab5c7d68bfba$export$2e2bcd8739ae039 extends (0, $llFKB.default) {
    Game = (0, $75RpY.default).getInstance();
    constructor(){
        super("Generate Random Quadrilateral", $2690ab5c7d68bfba$var$ButtonStyle, ()=>this.createRandomQuadri());
        this.addCoord();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    createRandomQuadri = ()=>(0, $497cd17e3d6f7072$export$f6644f0f2c90144b).emit((0, $497cd17e3d6f7072$export$cb883390c27ec6dd).generateRandomQuadri);
    setVisible = (v)=>this.visible = v;
    addCoord() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) {
            this.x = (0, $5be887b5ccefa13b$export$1312ecbb29a79419).x;
            this.y = (0, $5be887b5ccefa13b$export$1312ecbb29a79419).y;
            return;
        }
        this.x = dim.WIDTH / 2 - 200;
        this.y = dim.HEIGHT / 2 + 400;
    }
}



class $66cb9a722022b182$export$2e2bcd8739ae039 {
    static instance;
    Game = (0, $75RpY.default).getInstance();
    cRadius = (0, $5be887b5ccefa13b$export$ca8f2c484d507a5d);
    cCoord = (0, $5be887b5ccefa13b$export$c7609d9da8d80867);
    circle;
    PointManager;
    PointTagManager;
    LineManager;
    AngleManager;
    SupplAngleManager;
    CircleAnimationManager;
    CalcLineManager;
    SliderManager;
    infoSlider = new (0, $fGH3X.default)((0, $5be887b5ccefa13b$export$840ec2322406bfdd));
    constructor(){
        if (!$66cb9a722022b182$export$2e2bcd8739ae039.instance) $66cb9a722022b182$export$2e2bcd8739ae039.instance = this;
        const isVertical = this.isVertical();
        this.PointManager = new (0, $19e42c2d00c5ddae$export$2e2bcd8739ae039)();
        const radians = this.PointManager.getRadians();
        this.circle = new (0, $iiVV4.default)(this.cCoord, radians, Array(4).fill(0x000000));
        this.PointTagManager = new (0, $593a5621353877dc$export$2e2bcd8739ae039)(this.cCoord);
        this.LineManager = new (0, $600b65abf76d6aa0$export$2e2bcd8739ae039)();
        this.AngleManager = new (0, $79a59466696ba8ab$export$2e2bcd8739ae039)();
        this.SupplAngleManager = new (0, $562fc195b45cc3fe$export$2e2bcd8739ae039)();
        this.CalcLineManager = new (0, $ea241116ff1cc1b8$export$2e2bcd8739ae039)(isVertical);
        this.SliderManager = new (0, $3bfd9d882f819897$export$2e2bcd8739ae039)();
        this.CircleAnimationManager = new (0, $b8a34e639abcb296$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.SupplAngleManager, this.LineManager, this.CalcLineManager, this.circle, this.cCoord);
        new (0, $3DpJv.default)();
        new (0, $24aace51740879bb$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.LineManager);
        new (0, $37e377a4bc959501$export$2e2bcd8739ae039)();
        new (0, $2690ab5c7d68bfba$export$2e2bcd8739ae039)();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.drawElements());
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).drawElements, ()=>this.drawElements());
        this.drawElements();
    }
    static getInstance = ()=>$66cb9a722022b182$export$2e2bcd8739ae039.instance;
    isVertical() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return false;
        this.cCoord.x = dim.WIDTH / 2;
        this.cCoord.y = dim.HEIGHT / 2 - 100;
        return true;
    }
    drawElements() {
        const radians = this.PointManager.getRadians();
        const radius = this.PointManager.circleRadius;
        const redPointsCoord = this.PointManager.getRedPointsCoord();
        this.PointManager.draw();
        this.circle.draw({
            radians: [
                radians[1],
                radians[0]
            ],
            radius: radius
        });
        this.LineManager.draw(redPointsCoord);
        this.AngleManager.draw(redPointsCoord, false);
        this.SupplAngleManager.draw(redPointsCoord, false);
        this.PointTagManager.updateCoord(radians, radius + 30);
    }
}



const $bc311febc93935a5$var$canvas = document.querySelector("#canvas");
if ($bc311febc93935a5$var$canvas) window.context = new (0, $75RpY.default)($bc311febc93935a5$var$canvas, (0, $5be887b5ccefa13b$export$2e51dc0dfab2d766), ()=>new (0, $66cb9a722022b182$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.edf766fd.js.map
